module.exports = "<div class=\"spinner-border\" role=\"status\">\r\n    <span class=\"sr-only\">Loading...</span>\r\n</div>"